import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState } from 'react';
import { string, func, oneOfType, number, shape, arrayOf } from 'prop-types';
import { Close } from '@magalu/stereo-ui-icons';
import { currencyFormatter } from '@magalu/stereo-ui-utils';
import { Container, Label, Description, PriceInformation, SidebarHeader, SidebarTitle } from './best-installment.styles';
import { CardLabel, PaymentsWay } from './best-installment.data';
import PaymentMethods from '../../molecules/PaymentMethods';
import Sidebar from '../Sidebar';

const BestInstallment = _ref => {
  let {
    plan,
    payments,
    onClick,
    onClose,
    onPaymentMethodChange
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["plan", "payments", "onClick", "onClose", "onPaymentMethodChange"]);

  const [open, setOpen] = useState(false);

  const handleOpenSidebar = () => {
    setOpen(true);
    onClick(plan);
  };

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  const {
    paymentMethodDescription,
    totalAmount,
    quantity,
    amount
  } = plan;
  return /*#__PURE__*/React.createElement(Container, props, /*#__PURE__*/React.createElement(PriceInformation, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Label, {
    onClick: handleOpenSidebar,
    role: "button",
    "aria-hidden": true,
    "aria-label": "abrir m\xE9todos de pagamento"
  }, CardLabel), /*#__PURE__*/React.createElement(Description, null, paymentMethodDescription)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Description, {
    textAlign: "right"
  }, currencyFormatter({
    value: totalAmount
  })), /*#__PURE__*/React.createElement(Description, {
    fontWeight: "500"
  }, quantity, "x ", currencyFormatter({
    value: amount
  })))), /*#__PURE__*/React.createElement(Sidebar, {
    visible: open,
    direction: "right",
    onClickOutside: handleClose,
    "data-testid": "sidebar-payments"
  }, /*#__PURE__*/React.createElement(SidebarHeader, null, /*#__PURE__*/React.createElement(Close, {
    color: "#bcbcbc",
    onClick: handleClose,
    role: "button",
    title: "fechar m\xE9todos de pagamento"
  }), /*#__PURE__*/React.createElement(SidebarTitle, {
    fontWeight: "normal"
  }, PaymentsWay)), /*#__PURE__*/React.createElement(PaymentMethods, {
    payments: payments,
    onChange: onPaymentMethodChange
  })));
};

process.env.NODE_ENV !== "production" ? BestInstallment.propTypes = {
  plan: shape({
    paymentMethodDescription: oneOfType([string, number]),
    totalAmount: oneOfType([string, number]),
    quantity: oneOfType([string, number]),
    amount: oneOfType([string, number])
  }),
  payments: shape({
    luizaCard: shape({
      id: string,
      installmentPlans: arrayOf(shape({
        installment: number,
        installmentAmount: string,
        totalAmount: string
      }))
    }),
    creditCard: shape({
      id: string,
      installmentPlans: arrayOf(shape({
        installment: number,
        installmentAmount: string,
        totalAmount: string
      }))
    }),
    bankSlip: shape({
      id: string,
      discount: string,
      installmentAmount: string
    })
  }),
  onClick: func,
  onClose: func,
  onPaymentMethodChange: func
} : void 0;
BestInstallment.defaultProps = {
  plan: {},
  payments: {},
  onClick: () => ({}),
  onClose: () => ({}),
  onPaymentMethodChange: () => ({})
};
export default BestInstallment;